<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout column fill-height justify-start>
      <v-layout column fill-height justify-start>
        <v-layout fill-height ref="sessions" >
          <scroll-table
            :data="getTable"
            :options="getOptions"
            :sortable="false"
            @remove="(payload) => deleteSession(payload)"
            @select=""
          />
        </v-layout>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'

// Типы для сессий
interface Session {
  id?: string
  userName?: string
  ip?: string
  startRT?: string
  [key: string]: any
}

interface TableColumnAction {
  title: string
  tooltip: string
  icon: string
  color: string
  size: number
  emit: string
}

interface TableColumn {
  title: string
  value: string
  dataKey: string
  type: string
  width: string
  actions?: TableColumnAction[]
}

interface TableData {
  columns: TableColumn[]
  rows: Session[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ComponentData {
  data: any
}

export default Vue.extend({
  name: 'ADMIN_SETTINGS_MODAL',

  components: {
    loadingCircle,
    scrollTable
  },

  props: {
    data: {
      type: Object as () => ComponentData,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    sessions: Session[]
    options: OptionsData
    table: TableData
  } {
    return {
      loader: false,
      sessions: [],
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '20%' },
          check: { width: '5%' },
          actions: { width: '20%' }
        },
      },
      table: {
        columns: [
          {
            title: 'user',
            value: 'userName',
            dataKey: 'userName',
            type: 'text',
            width: '50%'
          },
          {
            title: 'ip address',
            value: 'ip',
            dataKey: 'ip',
            type: 'text',
            width: '30%'
          },
          {
            title: 'session start time',
            value: 'startRT',
            dataKey: 'startRT',
            type: 'timestamp',
            width: '15%'
          },
          {
            title: 'actions',
            value: '',
            dataKey: '',
            type: 'actions',
            width: '8%',
            actions: [
              {
                title: 'remove',
                tooltip: 'remove',
                icon: 'basket',
                color: 'red',
                size: 15,
                emit: 'remove'
              }
            ],
          }
        ],
        rows: []
      }
    }
  },

  computed: {
    getData(): ComponentData {
      return this.data
    },

    getSessions(): Session[] {
      return this.sessions
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      return t
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      console.log(this.$options.name, 'data', this.data)
      this.reset()
      this.loadSessions()
    },

    async loadSessions(): Promise<void> {
      const sessions = await this.$bridge.customQuery('alarm', 'auth/sessions', {}, 'GET')
      console.log(this.$options.name, 'sessions', sessions)
      if (sessions) {
        this.sessions = sessions
        this.table.rows = sessions
      }
    },

    async deleteSession(val: Session): Promise<void> {
      console.log(this.$options.name, 'deleteSession', val)
      const del = await this.$bridge.customQuery('alarm', `auth/session/${val.id}`, {}, 'DELETE')
      if (del) {
        this.loadSessions()
      }
    },

    reset(): void {}
  }
})
</script>

<style scoped>
</style>
